const help = (
  cmd: string,
  setHistory: React.Dispatch<React.SetStateAction<string[]>>
): string[] => {
  return [
    'Available Commands:',
    '',
    'help',
    '  Show this help message',
    '',
    'clear',
    '  Clear the terminal output',
    '',
    'Wallet:',
    '  connect <network>',
    '    Connect to a wallet (solana | ethereum | base | arbitrum | bnb | optimism)',
    '  disconnect',
    '    Disconnect the connected wallet',
    '  restore <privateKey>',
    '    Restore your wallet using the private key',
    '',
    'Funds:',
    '  balance',
    '    Show current wallet balance',
    '  withdraw',
    '    Send profit to the connected wallet address',
    '  stake',
    '    Send balance of a coin to the staking pool',
    '  unstake',
    '    Withdraw funds from the staking pool',
    '',
    'Mining:',
    '  mining start',
    '    Start mining',
    '  mining stop',
    '    Stop mining',
    '  mining profit',
    '    Show total mining earnings',
    '  mining reset',
    '    Reset mining earnings',
    '',
    'Support:',
    '  support',
    '    Get support info, tutorials, and contact links',
  ];
};

export default help;
